// api/client.service.js
import API from './axiosConfig';

// Get all clients
export const getClients = async () => {
  try {
    const response = await API.get('/api/clients');
    console.log('getClients response:', response.data); // Debug log
    
    // Handle different response structures
    if (response.data && Array.isArray(response.data)) {
      return { data: response.data };
    } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
      return response.data;
    } else {
      return { data: [] };
    }
  } catch (error) {
    console.error('Error in getClients:', error);
    return { data: [] };
  }
};

// Create new client
export const createClient = async (data) => {
  try {
    const response = await API.post('/api/clients', data);
    return response.data;
  } catch (error) {
    console.error('Error in createClient:', error);
    throw error;
  }
};

// Update client
export const updateClient = async (id, data) => {
  try {
    const response = await API.put(`/api/clients/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error in updateClient:', error);
    throw error;
  }
};

// Delete client
export const deleteClient = async (id) => {
  try {
    const response = await API.delete(`/api/clients/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error in deleteClient:', error);
    throw error;
  }
};

// Reset client password
export const resetClientPassword = async (id) => {
  try {
    const response = await API.post(`/api/clients/${id}/reset-password`);
    return response.data;
  } catch (error) {
    console.error('Error in resetClientPassword:', error);
    throw error;
  }
};

// Get unassigned countries
export const getUnassignedCountries = async () => {
  try {
    const response = await API.get('/api/admin/unassigned-countries');
    console.log('Unassigned countries response:', response.data);
    
    if (response.data && Array.isArray(response.data)) {
      return { data: response.data };
    } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
      return response.data;
    } else {
      return { data: [] };
    }
  } catch (error) {
    console.error('Error in getUnassignedCountries:', error);
    return { data: [] };
  }
};

// Assign country to client
export const assignCountryToClient = async (data) => {
  try {
    const response = await API.post('/api/admin/assign-country', data);
    return response.data;
  } catch (error) {
    console.error('Error in assignCountryToClient:', error);
    throw error;
  }
};

// Get client data count
export const getClientDataCount = async (clientId) => {
  try {
    const response = await API.get(`/api/clients/${clientId}/data-count`);
    return response.data;
  } catch (error) {
    console.error('Error in getClientDataCount:', error);
    return { data: { countries_count: 0, destinations_count: 0, activities_count: 0 } };
  }
};